
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/document-collection-and-filing",
      function () {
        return require("private-next-pages/ai/document-collection-and-filing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/document-collection-and-filing"])
      });
    }
  